import { UPFLOWY_DOM_WATCHED } from '../settings';

function findAnyElements() {
  const allElements = document.querySelectorAll('body *');
  return Array.from(allElements).filter((element) => !element.hasAttribute(UPFLOWY_DOM_WATCHED));
}

export default findAnyElements;
